import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminTickets = lazy(() => import("@/pages/admin/AdminTickets"));

export const Route = createFileRoute("/admin/arenden/")({
  component: () => <AdminTickets />,
});
